var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/**
 * Script loader for dynamically loading external scripts.
 */
var ScriptLoader = /** @class */ (function () {
    function ScriptLoader() {
    }
    /**
     * Synchronously load all JSRoot scripts. ONLY CALL ONCE.
     * @param onScriptsLoaded Callback when all the JSRoot scripts have loaded.
     */
    ScriptLoader.loadJSRootScripts = function (onScriptsLoaded) {
        var _this = this;
        (function () { return __awaiter(_this, void 0, void 0, function () {
            var allScripts, _i, allScripts_1, script;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        allScripts = [
                            'JSRootCore.js', 'three.min.js', 'three.extra.min.js',
                            'ThreeCSG.js', 'd3.min.js', 'JSRootPainter.js', 'JSRoot3DPainter.js',
                            'JSRootGeoBase.js', 'JSRootGeoPainter.js'
                        ];
                        _i = 0, allScripts_1 = allScripts;
                        _a.label = 1;
                    case 1:
                        if (!(_i < allScripts_1.length)) return [3 /*break*/, 4];
                        script = allScripts_1[_i];
                        return [4 /*yield*/, ScriptLoader.loadScript('assets/jsroot/' + script, 'JSROOT')];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        _i++;
                        return [3 /*break*/, 1];
                    case 4:
                        onScriptsLoaded(JSROOT);
                        return [2 /*return*/];
                }
            });
        }); })();
    };
    /**
     * Load a script dynamically from a URL.
     * @param scriptURL URL of the script to be loaded.
     * @param scriptFor Optional data attribute to identify what the script is for. `[data-scriptFor]`
     * @param parentElement Parent element to which the script is to be appended.
     * Defaults to `<head>` tag.
     * @returns Promise for the script load.
     */
    ScriptLoader.loadScript = function (scriptURL, scriptFor, parentElement) {
        if (parentElement === void 0) { parentElement = document.getElementsByTagName('head')[0]; }
        return new Promise(function (resolve, reject) {
            var scriptExists = document
                .querySelectorAll('script[src="' + scriptURL + '"]');
            // If no script exists - add one
            if (scriptExists.length === 0) {
                var scriptElement_1 = document.createElement('script');
                scriptElement_1.type = 'text/javascript';
                scriptElement_1.src = scriptURL;
                if (scriptFor) {
                    scriptElement_1.setAttribute('data-scriptfor', scriptFor);
                }
                scriptElement_1.addEventListener('load', function () {
                    scriptElement_1.setAttribute('data-loaded', 'true');
                    resolve();
                });
                scriptElement_1.onerror = function (event) {
                    console.error('ERROR LOADING SCRIPT: ', event);
                    reject();
                };
                parentElement.appendChild(scriptElement_1);
            }
            else {
                // If script has already loaded then resolve else wait for it to load
                if (scriptExists[0].dataset.loaded === 'true') {
                    resolve();
                }
                else {
                    scriptExists[0].addEventListener('load', function () {
                        resolve();
                    });
                }
            }
        });
    };
    return ScriptLoader;
}());
export { ScriptLoader };
//# sourceMappingURL=script-loader.js.map